module.exports = __webpack_public_path__ + "img/minus.bdefa523.svg";